<ef-project-budget-add
    [tasks]="tasksSelectItems$ | async"
    [serviceItems]="serviceItemsSelectItems$ | async"
    [users]="usersSelectItems$ | async"
    [costTypes]="costTypesSelectItems$ | async"
    [contract]="config.data.contract"
    [payrollItems]="payrollItem$ | async"
    [costCenters]="costCenterSelectItems$ | async"
    (Save)="onSave($event)"
    (Cancel)="onCancel()"
></ef-project-budget-add>
